const en = require('./en.json');
const pl = require('./pl.json');
const ja = require('./ja.json');

export default { en, pl, ja };
